const contractList = {
  layout: 'contract-list-layout',
  searchInput: 'contract-search',
  filterTabActive: 'filter-tab-active',
  filterTabUpcoming: 'filter-tab-upcoming',
  filterTabPast: 'filter-tab-past',
  roleToggleHiring: 'role-toggle-hiring',
  roleToggleHired: 'role-toggle-hired',
  card: 'contract-card',
  cardCount: 'contract-card-count',
  loadMore: 'contract-list-load-more',
  summaryCard: 'contracts-summary-card',
};

const contractDetail = {
  layout: 'contract-detail-layout',
  status: 'detail-status',
  signBtn: 'sign-contract-btn',
  terminateBtn: 'terminate-contract-btn',
  terminationStatus: 'termination-status',
  withdrawTerminationBtn: 'withdraw-termination-btn',
  terminationReason: 'termination-reason',
  terminationConfirm: 'termination-confirm',
  terminationCancel: 'termination-cancel',
  signDialog: 'sign-contract-dialog',
  signerName: 'sign-contract-name',
  signConsent: 'sign-contract-consent',
  signError: 'sign-contract-error',
  signConfirm: 'sign-contract-confirm',
  signCancel: 'sign-contract-cancel',
  partySignature: 'party-signature',
};

export default {
  contractList,
  contractDetail,
};
